module.exports = __webpack_public_path__ + "static/media/ic_image_empty.57f68838.svg";